import React from 'react';
import PackingTable from './PackingTable';
import ShippingInfo from './ShippingInfo';
import CompanySection from './CompanySection';
import PackageSummary from './PackageSummary';
import Signature from './Signature';

const PackingList = ({ data }) => {
  return (
    <div className="invoice-container">
      {/* Header */}
      <div className="invoice-header">
        <h1 className="invoice-title">PACKING LIST</h1>
        <div style={{textAlign: 'right'}}>
          <img 
            src="https://blackvue.com/wp-content/uploads/2024/10/logo-w.svg" 
            alt="BlackVue Logo" 
            style={{
              width: '120px', 
              height: '30px', 
              marginBottom: '5px', 
              filter: 'brightness(0) saturate(100%)'
            }} 
          />
          <div className="invoice-info">
            <div>Invoice No : {data.invoiceNo}</div>
            <div>P/O Number : {data.poNumber}</div>
            <div>Invoice Date : {data.invoiceDate}</div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <CompanySection data={data} />

      {/* Shipping Information */}
      <ShippingInfo data={data} />

      {/* Packing Table */}
      <PackingTable items={data.items} />

      {/* Package Summary */}
      <PackageSummary summary={data.packageSummary} />

      {/* Signature */}
      <Signature data={data} />
    </div>
  );
};

export default PackingList;